export default __webpack_public_path__ + "images/image3.1aaf3cc0.png";